module.exports = __webpack_public_path__ + "img/puzzel1-4.b3aaf44d.png";